
import React from "react";

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: React.ReactNode;
  error?: React.ReactNode;
  helperText?: React.ReactNode;
  containerClassName?: string;
  variant?: "bordered" | "underline";
}

const borderedClass =
  "block w-full appearance-none rounded-lg border border-solid border-line-strong bg-surface bg-clip-padding px-3 py-2 text-sm font-normal leading-5.6 text-content-2 outline-none transition-all ease-soft placeholder:text-content-3 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 disabled:bg-sunken";

const underlineClass =
  "block w-full appearance-none border-0 border-b border-transparent bg-transparent px-1 py-1 text-sm font-normal text-content-2 outline-none transition-colors placeholder:text-content-muted hover:border-line-strong focus:border-primary focus:outline-none";

/**
 * Design-System-Textarea. Native input-Props + forwardRef → controlled UND
 * react-hook-form `register`. Token-/theme-aware; Varianten bordered (Default)
 * und underline analog {@link Input}.
 */
export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { label, error, helperText, containerClassName = "", className = "", variant = "bordered", ...props },
  ref,
) {
  const baseClass = variant === "underline" ? underlineClass : borderedClass;

  return (
    <div className={containerClassName}>
      {label && <label className="text-content-2 mb-2 block text-sm font-medium">{label}</label>}
      <textarea
        ref={ref}
        aria-invalid={error ? true : undefined}
        className={`${baseClass} ${error ? "border-danger focus:border-danger" : ""} ${className}`}
        {...props}
      />
      {error && <p className="text-danger mt-1 text-sm">{error}</p>}
      {helperText && !error && <p className="text-content-3 mt-1 text-xs">{helperText}</p>}
    </div>
  );
});
